<p-autoComplete
  appendTo="body"
  field="label"
  [minQueryLength]="2"
  [suggestions]="suggestions"
  [disabled]="disabled"
  [ngModel]="value"
  [forceSelection]="true"
  (completeMethod)="loadUsers($event)"
  (onClear)="onClear()"
  (onSelect)="selectUser($event.value)"
/>
